import { IsBoolean, IsOptional, Length, Max, Min } from 'class-validator';

import { AuctionTypeEnum } from '@onArte/shared/enums/common';
import { RangeModel } from '@onArte/shared/models/common';

export class AuctionCreateOnManagementModel {
  @Length(32, 36)
  public itemId: string;

  @IsOptional()
  @Length(32, 36)
  public eventId?: string;

  @Length(6, 32)
  public type: AuctionTypeEnum;

  @IsOptional()
  @Min(1)
  @Max(1000000)
  public startPrice?: number;

  @IsOptional()
  @Min(1)
  @Max(1000000)
  public acceptablePrice?: number;

  @IsOptional()
  public estimation?: RangeModel<number>;

  @IsOptional()
  public validity?: RangeModel<number>;

  @IsBoolean()
  public highlighted: boolean;

  constructor(
    type: AuctionTypeEnum,
    eventId?: string,
    startPrice?: number,
    acceptablePrice?: number,
    estimation?: RangeModel,
    validity?: RangeModel,
    highlighted: boolean = false
  ) {
    this.type = type;
    this.eventId = eventId;
    this.startPrice = startPrice;
    this.acceptablePrice = acceptablePrice;
    this.estimation = estimation;
    this.validity = validity;
    this.highlighted = highlighted;
  }
}
